import { useTranslation } from "react-i18next";
import { useState } from "react";
import { buildLanguageUrl } from "../utils/buildLanguageUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck
} from "@fortawesome/pro-regular-svg-icons";

const LanguageOptionMenu = () => {
    const { t, i18n } = useTranslation();
    const [hoveredLanguage, setHoveredLanguage] = useState(null);
    
    // @ts-ignore
    const currentLang = window.wpml_language_codes?.current_lang || "en";
    // @ts-ignore
    const languageCodes = window.wpml_language_codes?.language_codes || [];
    // @ts-ignore
    const languageAttributes = window.wpml_language_codes?.language_attributes || {};

    const handleLanguageClick = (languageCode) => {
        const newUrl = buildLanguageUrl(languageCode);
        
        i18n.changeLanguage(languageCode);
        window.location.href = newUrl;
    };

    const isActiveLanguage = (languageCode) => {
        return currentLang === languageCode;
    };

    return (
        <div className="language-option-menu">
            <h3 className="language-option-menu__title">{t("Select Language")}</h3>
            <div className="language-option-menu__items">
                {languageCodes.map(languageCode => {
                    const langData = languageAttributes[languageCode];
                    if (!langData) return null;
                    
                    return (
                        <div key={languageCode} className="language-option-menu__item-wrapper">
                            <button 
                                className={`language-option-menu__item flag-icon-${languageCode} ${isActiveLanguage(languageCode) ? "is-active" : ""}`}
                                onClick={() => handleLanguageClick(languageCode)}
                                onMouseEnter={() => setHoveredLanguage(languageCode)}
                                onMouseLeave={() => setHoveredLanguage(null)}
                            >
                                <FontAwesomeIcon
                                    className="language-option-menu__item-check"
                                    icon={faCheck}
                                    style={{ color: "#fff" }}
                                />
                                <img 
                                    src={langData.flag} 
                                    alt={langData.name}
                                />
                            </button>
                            {hoveredLanguage === languageCode && (
                                <div className="language-option-menu__tooltip">
                                    {langData.name}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LanguageOptionMenu;